import {
    BellOutlined,
    DownloadOutlined,
    PlusOutlined,
    SearchOutlined,
    UploadOutlined
} from "@ant-design/icons";
import Icon from "@ant-design/icons";
import {Row, Upload} from "antd";
import {GiFullMotorcycleHelmet} from "react-icons/gi";
import {CustomButton} from "components/_defaultComponents/CustomButton/CustomButton";
import {VFlex} from "components/_defaultComponents/Flex/VFlex";
import {CloseIcon, SearchInput} from "components/courier/courierPageStyles";
import {useStore} from "hooks/useStore";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {useCourierFilter} from "../context/useCourierFilter";
import {useWindowSize} from "hooks/useWindowSize";
import {normalizeStringSearchFilter} from "utils/helpers";
import {SendAnnouncementModal} from "./SendAnnouncementModal";
import {SendAnnouncementWithExcelModal} from "./SendAnnouncementWithExcelModal";
import {ExportExcelModal} from "./ExportExcelModal";
import {CreateCourierCandidateModal} from "./CreateCourierCandidateModal";
import EquipmentRequestModal from "./equipment/EquipmentRequestModal";

const ActionButtons = ({
    loadingExcelData,
    getExcelTemplateData,
    setLoadingExcelData,
    fileUploadProps,
    dataCount
}) => {
    const stores = useStore();
    const {t} = useTranslation(["courierPage"]);
    const {state, dispatch, resetFilters, getFilterParams, isAgency} = useCourierFilter();
    const isMobile = useWindowSize().width <= 768;
    const [announcementModalVisible, setAnnouncementModalVisible] = useState(false);
    const [excelAnnouncementModalVisible, setExcelAnnouncementModalVisible] = useState(false);
    const [exportModalVisible, setExportModalVisible] = useState(false);
    const [candidateModalVisible, setCandidateModalVisible] = useState(false);
    const [equipmentRequestModalVisible, setEquipmentRequestModalVisible] = useState(false);
    // Mevcut rol/sayfa-izni kontrolüne ek olarak, dinamik yetki sisteminden
    // (permissionPolicy) gelen izin de kanalları açabilir; eski akış korunur.
    // app ve whatsapp ayrı operationId'ler olduğundan izin de kanal bazlı hesaplanır.
    const canSendAppAnnouncement =
        (stores.meStore.checkRole("sendAnnouncement") &&
            stores.meStore.checkPermission("couriers.sendAnnouncement")) ||
        stores.meStore.can("sendAnnouncementNotification");
    const canSendWhatsappAnnouncement =
        (stores.meStore.checkRole("sendWhatsappAnnouncement") &&
            stores.meStore.checkPermission("couriers.sendAnnouncement")) ||
        stores.meStore.can("sendWhatsAppAnnouncement");
    const canSendAnnouncement = canSendAppAnnouncement || canSendWhatsappAnnouncement;

    const canSendAppAnnouncementWithExcel =
        !isAgency &&
        (stores.meStore.checkRole("sendAnnouncementWithExcel") ||
            stores.meStore.can("sendAnnouncementNotificationByExcel"));
    const canSendWhatsappAnnouncementWithExcel =
        !isAgency &&
        (stores.meStore.checkRole("sendWhatsappAnnouncementWithExcel") ||
            stores.meStore.can("sendWhatsAppAnnouncementByExcel"));
    const canSendAnnouncementWithExcel =
        canSendAppAnnouncementWithExcel || canSendWhatsappAnnouncementWithExcel;
    return (
        <>
            <VFlex justify="end" wrap flex={!isMobile} gap={isMobile && 16}>
                <VFlex wrap>
                    {canSendAnnouncement && (
                        <CustomButton
                            style={{marginTop: "0px"}}
                            data-testid="sendAnnouncementButton"
                            icon={<BellOutlined />}
                            onClick={event => {
                                event.stopPropagation();
                                setAnnouncementModalVisible(true);
                            }}
                        >
                            {`Filtrelenen Kuryelere Duyuru Gönder (${dataCount} Kurye)`}
                        </CustomButton>
                    )}
                    {canSendAnnouncementWithExcel && (
                        <CustomButton
                            style={{marginTop: "0px"}}
                            data-testid="sendAnnouncementWithExcelButton"
                            icon={<BellOutlined />}
                            onClick={event => {
                                event.stopPropagation();
                                setExcelAnnouncementModalVisible(true);
                            }}
                        >
                            Excel ile Duyuru Gönder
                        </CustomButton>
                    )}
                    {!isAgency && (
                        <CustomButton
                            style={{marginTop: "0px"}}
                            type="primary"
                            data-testid="exportWithExcelButton"
                            onClick={event => {
                                event.stopPropagation();
                                setExportModalVisible(true);
                            }}
                            loading={loadingExcelData}
                            icon={<DownloadOutlined />}
                        >
                            {isMobile ? "" : "Excel Çıktısı İndir"}
                        </CustomButton>
                    )}

                    {isAgency && stores.meStore.checkPermission("couriers.equipment") && (
                        <CustomButton
                            style={{marginTop: "0px"}}
                            data-testid="equipmentRequestButton"
                            icon={<Icon component={GiFullMotorcycleHelmet} />}
                            onClick={event => {
                                event.stopPropagation();
                                setEquipmentRequestModalVisible(true);
                            }}
                        >
                            {isMobile ? "" : "Ekipman Talep Et"}
                        </CustomButton>
                    )}

                    {stores.meStore.checkRole("newCourier") && (
                        <>
                            <Upload
                                {...fileUploadProps}
                                accept=".xlsx,.xls,.csv,.tsv"
                                onClick={event => {
                                    event.stopPropagation();
                                }}
                            >
                                <CustomButton
                                    style={{marginTop: "0px"}}
                                    icon={<UploadOutlined />}
                                    data-testid="importFromExcelButton"
                                >
                                    {isMobile
                                        ? ""
                                        : t("actions.importFromExcel", {
                                              ns: "courierPage"
                                          })}
                                </CustomButton>
                            </Upload>
                            <CustomButton
                                style={{marginTop: "0px", marginRight: isMobile && 0}}
                                type="primary"
                                data-testid="newCourierButton"
                                onClick={event => {
                                    event.stopPropagation();
                                    setCandidateModalVisible(true);
                                }}
                                icon={<PlusOutlined />}
                            >
                                {isMobile
                                    ? ""
                                    : t("actions.newCourier", {
                                          ns: "courierPage"
                                      })}
                            </CustomButton>
                        </>
                    )}
                </VFlex>
                <VFlex minWidth={200} wrap>
                    <SearchInput
                        value={state.text}
                        data-testid="searchInput"
                        onSearch={value => {
                            const normalizedValue = normalizeStringSearchFilter(value);
                            resetFilters();
                            dispatch({type: "text", payload: value});
                            dispatch({type: "searchText", payload: normalizedValue});
                        }}
                        onChange={event => {
                            dispatch({
                                type: "REPLACE_STATE",
                                payload: {
                                    ...state,
                                    currentPage: 1,
                                    text: event.target.value
                                }
                            });
                        }}
                        enterButton={
                            <CustomButton
                                data-testid="searchInput_searchButton"
                                icon={<SearchOutlined />}
                                style={{marginRight: "0px"}}
                            />
                        }
                        suffix={
                            state.text ? (
                                <CloseIcon
                                    data-testid="searchInput_deleteButton"
                                    onClick={() => {
                                        dispatch({type: "currentPage", payload: 1});
                                        dispatch({type: "searchText", payload: ""});
                                        dispatch({type: "text", payload: ""});
                                    }}
                                />
                            ) : (
                                <span />
                            )
                        }
                        placeholder={"İsim, Telefon, TCKN, Plaka Ara"}
                    />
                </VFlex>
            </VFlex>
            <SendAnnouncementModal
                visible={announcementModalVisible}
                onClose={() => setAnnouncementModalVisible(false)}
                filterParams={getFilterParams()}
                allowedChannels={{app: canSendAppAnnouncement, whatsapp: canSendWhatsappAnnouncement}}
            />
            <SendAnnouncementWithExcelModal
                visible={excelAnnouncementModalVisible}
                onClose={() => setExcelAnnouncementModalVisible(false)}
                allowedChannels={{
                    app: canSendAppAnnouncementWithExcel,
                    whatsapp: canSendWhatsappAnnouncementWithExcel
                }}
            />
            <ExportExcelModal
                visible={exportModalVisible}
                onClose={() => setExportModalVisible(false)}
                confirmLoading={loadingExcelData}
                onConfirm={async language => {
                    setLoadingExcelData(true);
                    await getExcelTemplateData(language);
                    setExportModalVisible(false);
                }}
            />
            <CreateCourierCandidateModal
                visibility={candidateModalVisible}
                onCancel={() => setCandidateModalVisible(false)}
                callbackFunc={() => dispatch({type: "recall", payload: !state.recall})}
            />
            <EquipmentRequestModal
                visible={equipmentRequestModalVisible}
                onClose={() => setEquipmentRequestModalVisible(false)}
            />
        </>
    );
};

export default ActionButtons;
